export default function removeQueryString(input: string) {
  if (input.indexOf("?") === -1) return input;
  return input.split("?")[0];
}
